import { render } from "./configuration-blog.vue?vue&type=template&id=5686ae19"
import script from "./configuration-blog.vue?vue&type=script&lang=js"
export * from "./configuration-blog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__